import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';

const propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

const AssignUserDialog = ({ open, handleClose }) => (
  <Dialog
    className="custom-modal-dialog confirmation-modal-dialog"
    open={open}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent className="dialog-content">
      <DialogContentText id="alert-dialog-description">
        You cannot assign multiple skills to a user
      </DialogContentText>
    </DialogContent>
    <DialogActions className="dialog-actions">
      <Button danger onClick={handleClose}>Ok</Button>
    </DialogActions>
  </Dialog>
);

AssignUserDialog.propTypes = propTypes;
export default AssignUserDialog;
